import { computed } from 'vue'
import { useRoute } from 'vue-router'

import router from '@/router'
import { redirectToStayDisplayer } from '@/stay-list/stay-list-table/helpers/line/lineHelper'
import { useStore } from '@/store'

export default function useStayRedirection(stayDisplayerPath: string) {
  const store = useStore()
  const route = useRoute()

  const settingsUrlQuery = computed(() => store.getters.settingsUrlQuery)

  const viewStay = (event: MouseEvent, forceNewWindow: boolean | null = null) =>
    redirectToStayDisplayer(event, forceNewWindow, router, {
      routeFullPath: route.fullPath,
      newRoute: {
        path: stayDisplayerPath,
        query: {
          ...route.query,
          ...settingsUrlQuery.value,
        },
      }
    })

  return {
    viewStay
  }
}
